module.exports = __webpack_public_path__ + "img/3.9f44e625.png";